const DEFAULT_ID_LENGTH = 12;

export default function createId(
  length: number = DEFAULT_ID_LENGTH,
  charset: string = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
) {
  return Array.from(window.crypto.getRandomValues(new Uint32Array(length)))
    .map<string>((number) => charset[number % charset.length])
    .join('');
}
